// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__5B5bV","title":"AfterBackImages_title__1Wpyy","images":"AfterBackImages_images__h1vhc"};